import { render, staticRenderFns } from "./sort-shoe.vue?vue&type=template&id=1f642644&scoped=true"
import script from "./sort-shoe.vue?vue&type=script&lang=js"
export * from "./sort-shoe.vue?vue&type=script&lang=js"
import style0 from "./sort-shoe.vue?vue&type=style&index=0&id=1f642644&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f642644",
  null
  
)

export default component.exports